import React from 'react';
import {connect} from 'react-redux'
import {Route, Switch, withRouter} from 'react-router-dom'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import {clearAlert, clearState} from 'Skelet/src/modules/fetch.action.js'
import AlertBar from 'Skelet/src/components/AlertBar.js'
import Start from './Start.js'
import PageNotFound from 'Skelet/src/components/PageNotFound.js'
import Events from './Events.js'
import AutoGetChannel from './AutoGetChannel.js'
import TTVChannels from './TTVChannels.js'
import EventSearch from './EventSearch.js'
import CoreRoute from './route-containers/CoreRoute.js'
import StartRoute from './route-containers/StartRoute.js'


class App extends React.Component {

  componentDidUpdate(prevProps) {
    const isLoggingOut = prevProps.session_token && !this.props.session_token
    const isLoggingIn = !prevProps.session_token && this.props.session_token

    if (isLoggingIn) {
      if(this.props.redirectUrl) {
        this.props.push(this.props.redirectUrl);
      } else {
        this.props.push("/");
      }
    } else if (isLoggingOut) {
      this.props.clearState();
      this.props.push("/start");
    }
  }

  render() {
    return (
      <div id="main">
        <Switch>
          <StartRoute exact path="/start" component={Start} />

          <CoreRoute exact path="/" component={Events} />

          <CoreRoute exact path="/auto-get-channel" component={AutoGetChannel} />

          <CoreRoute exact path="/ttv-channels" component={TTVChannels} />

          <CoreRoute exact path="/event-search" component={EventSearch} />

          <Route path="*" component={PageNotFound} />
        </Switch>
        <AlertBar alert={this.props.alert} clearAlert={this.props.clearAlert} />
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    state_router: state.router, // needed for redirect after login
    session_token: session_token,
    redirectUrl: state.apiData.redirectUrl,
    alert: state.apiData.alert,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    clearAlert,
    clearState,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/_app.js